import { SectionType } from "../enums/section-type";
export const SectionDetailsList = [
    {
        id: SectionType.SECTION1,
        label: "HEADER_SECTION_LABEL.EARN_WELLBUX"
    },
    {
        id: SectionType.SECTION2,
        label: "HEADER_SECTION_LABEL.FEATURES"
    },
    {
        id: SectionType.SECTION3,
        label: "HEADER_SECTION_LABEL.BENEFITS_OF_MERCHANT"
    },
    {
        id: SectionType.SECTION4,
        label: "HEADER_SECTION_LABEL.ABOUT_WELLBUX"
    }
] as const